import type { UserAuthResponse, UserAuth } from '../../common/types';

export const userAuthTransformer = (response: UserAuthResponse): UserAuth => ({
	clientId: response.id,
	token: response.token,
	tokenLifespanInMs: response.tokenDurationInMins * 60 * 1000,
	tokenIssueTimestamp: Date.now() - 10000, // added 10s buffer to cover network calls
});
